/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {}
 */
export interface ApiKeySearchRequest {
    /** The filter to apply to the search. */
    filter?: Truvity.ApiKeyFilter[];
    /** The sort order to apply to the search. */
    sort?: Truvity.ApiKeySort[];
}
